import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import OrcidSucceededConnections from './components/OrcidSucceededConnections';
import OrcidFailedConnections from './components/OrcidFailedConnections';
import OrcidReports from './components/OrcidReports';
import { TabPanel, TabView } from 'primereact/tabview';
import { AuthContext } from '../../../../Auth/components/AuthProvider';
import { Layout } from '../../../Layout';

export function AdminAreaOrcid(): ReactNode {
  const {session} = useContext(AuthContext);
  const username: string = session.user_name;
  const intl: IntlShape = useIntl();
  return (
    <Layout>
      <TabView>
        <TabPanel header={intl.formatMessage({id: 'orcidAdminArea.tab.succeededConnections'})}>
          <OrcidSucceededConnections userName={username}/>
        </TabPanel>
        <TabPanel header={intl.formatMessage({id: 'orcidAdminArea.tab.failedConnections'})}>
          <OrcidFailedConnections userName={username}/>
        </TabPanel>
        <TabPanel header={intl.formatMessage({id: 'orcidAdminArea.tab.reports'})}>
          <OrcidReports userName={username}/>
        </TabPanel>
      </TabView>
    </Layout>
  );
}

export default AdminAreaOrcid;
